module.exports = __webpack_public_path__ + "static/media/p3_s3a.e76b08ed.ogg";